import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MainHeader from "./main-header/MainHeader";
import News from "./news/News";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import VerticalHeader from "./main-header/VerticalHeader";
import { Container } from "react-bootstrap";
import Navbar from "./navbar/Navbar";
import { ChatConfig } from "../../pages/utility/ChatConfig";
import { SeoDymanicContent } from "../../pages/utility/SeoDymanicContent";
import ErrorBoundary from '../../helpers/ExceptionHandler/componentException';
import '../../helpers/ExceptionHandler/globleException';
import LiveChat from "../../components/livechat/LiveChat";


const Header = (props) => {

  const navigate = useNavigate();
  // Fetch component setting
  const { componentSetting } = useSelector((state) => ({
    componentSetting: state.componentSettingListR.data,
  }));
  let loggedIn = window.localStorage.getItem("user_token");

  return (
    <>
      <ChatConfig loggedIn={loggedIn} />
      <LiveChat ShowChatBox={true} />
      <ErrorBoundary>
        <SeoDymanicContent payload={'seo'} />
      </ErrorBoundary>
      <header className="header border-header background-header">
        <Container>
          {typeof componentSetting?.["top-nav-menus"] != "undefined" &&
            componentSetting?.["top-nav-menus"]?.["default-value"] &&
            (componentSetting?.["nav-bar"]?.["default-value"] ==
              "horizonatal" ||
              componentSetting?.["nav-bar"]?.["default-value"] ==
              "nav-carozal") && <ErrorBoundary><MainHeader showAuthHeader={props?.showAuthHeader} /></ErrorBoundary>}
          {componentSetting?.["nav-bar"]?.["default-value"] == "vertical" && (
            <ErrorBoundary><VerticalHeader sideMenuClickProp={props.sideMenuClickProp} /></ErrorBoundary>
          )}

          {/* {typeof componentSetting?.["news"] != "undefined" &&
            componentSetting?.["news"]?.["default-value"] && <News />} */}
            <News/>

          {componentSetting?.["nav-bar"]?.["default-value"] == "horizonatal" &&
            componentSetting?.custom_loading?.options?.navbar_handle && (
              <ErrorBoundary><Navbar showAuthHeader={props?.showAuthHeader} /></ErrorBoundary>
            )}
        </Container>
      </header>
    </>
  );
};

Header.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(Header);
